export default __webpack_public_path__ + "static/small-image-yangol-3-2e914b98641a6aa0e7d33a1d0e4fa90e.png";